













































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'

settings =
  vue:
    data: ->
      loginAttempts: 0
      error: null
      isSubmitting: false
      login:
        email: null
        password: null

    computed:
      afterLoginUrl: ->
        @$route.query.ref || '/'

    methods:
      loginClicked: () ->
        @error = null
        return if !(@login.email && @login.password)
        @isSubmitting = true
        try 
          response = await RecessAPI.authenticate { login : @login }
          @isSubmitting = false
          @loginAttempts = response.item.login_attempts
          @error = response.errors.error if response.errors?
          if !response.errors?
            @setCurrentMember(response.item)
            window.location.href = @afterLoginUrl # @navigateToDashboard() # reactivity doesnt work after login
        catch err
          # api error
          @isSubmitting = false
    mounted: -> @logout()

export default VueOptions.vue settings
